import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useLimitedRegistrationField } from '../../../../../hooks/useLimitedRegistrationField';
import { RegistrationField, TextValueOption } from '../../../../../interfaces/interfaces';
import VyModal from '../../../../common/VyModal';
import { RegistrationFormFieldProps } from '../../RegistrationFormField';
import { CardOption } from './CardOption';

interface CardSelectFieldInterface extends Omit<RegistrationFormFieldProps, 'register' | 'watch'> {
  isRequired: (field: RegistrationField) => boolean;
  setValue?: (name: string, value: any) => void;
  watch?: any;
  limitedFieldsLoaded?: boolean;
}

export const CardSelectField = ({
  field: registrationField,
  defaultValue,
  disabled,
  fieldsTextColor,
  fieldsBorderColor,
  selectFieldSelectedColor,
  variant,
  requiredFieldIds,
  limitedValuesCount,
  isRequired,
  updateRequiredFieldIds,
  showFieldLabel,
  limitedFieldsLoaded,
}: CardSelectFieldInterface) => {
  const { control } = useFormContext();
  const [showAdditionalInfos, setShowAdditionalInfos] = useState<TextValueOption>();

  const { isFieldOptionDisabled } = useLimitedRegistrationField();

  if (!limitedFieldsLoaded) return null;
  return (
    <>
      <VyModal open={!!showAdditionalInfos} title="" onClose={() => setShowAdditionalInfos(undefined)} hasDefaultPadding={true}>
        {() => <div dangerouslySetInnerHTML={{ __html: showAdditionalInfos?.additionalInformation ?? '' }}></div>}
      </VyModal>
      <Controller
        control={control}
        name={registrationField._id}
        key={registrationField._id}
        rules={{ required: isRequired(registrationField) }}
        defaultValue={defaultValue || ''}
        render={({ field: { onChange, value } }) => (
          <div className="grid grid-cols-1 @md:grid-cols-2 @lg:grid-cols-4 gap-4">
            {registrationField.textValueOptions
              .slice()
              .filter((tvo) => !tvo.isCustom)
              .sort((a, b) => a.sortIndex - b.sortIndex)
              .map((tvo, i) => {
                return (
                  <CardOption
                    disabled={isFieldOptionDisabled(registrationField, tvo, limitedValuesCount)}
                    key={`tvo-${tvo._id}`}
                    tvo={tvo}
                    onChange={onChange}
                    field={registrationField}
                    value={value}
                    onShowAdditionalInfos={setShowAdditionalInfos}
                    fieldsTextColor={fieldsTextColor}
                    fieldsBorderColor={fieldsBorderColor}
                  />
                );
              })}
          </div>
        )}
      />
    </>
  );
};
